<template>
  <div style="display: contents">
    <button :aria-label="`Suchen (${shortcut})`" class="shell-cmd" type="button" @click="showSearchPalette = true">
      <v-icon small>mdi-magnify</v-icon>
      <span class="shell-cmd__text">Suchen … Schüler:innen, Eltern, Mitarbeitende, Standorte, Kurse, Produkte</span>
      <kbd>{{ shortcut }}</kbd>
    </button>
    <!-- The palette registers the ⌘K / Strg+K shortcut itself, so it lives as long as the app bar is shown -->
    <search-palette v-model="showSearchPalette"/>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import {shortcutLabel} from '@/helpers/shortcut.helper';
import SearchPalette from '@/components/app/search/searchPalette.vue';

/** Always visible search field of the app bar; opens the search palette (also with ⌘K / Strg+K) */
export default Vue.extend({
  components: {SearchPalette},
  data: () => ({
    showSearchPalette: false,
  }),
  computed: {
    shortcut(): string {
      return shortcutLabel('K');
    },
  },
});
</script>
